'use client';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Award, ExternalLink } from 'lucide-react';
import { certificationsApi } from '@/lib/api';
import { Certification } from '@/types';

export default function Certifications() {
  const [certs, setCerts] = useState<Certification[]>([]);

  useEffect(() => {
    certificationsApi.getAll().then(setCerts).catch(() => {});
  }, []);

  return (
    <section id="certifications" className="section">
      <div className="container">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <div className="accent-line" />
          <h2 className="section-title">Certifications</h2>
          <p className="section-subtitle">Credentials & achievements</p>
        </motion.div>

        {certs.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem 0' }}>No certifications added yet. Add them from the Django admin.</div>

        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem' }}>
            {certs.map((cert, i) => (
              <motion.div key={cert.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }} className="card" style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: 'var(--bg-surface)', border: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: 'var(--accent)' }}>
                  <Award size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 600, fontSize: '0.95rem', marginBottom: '0.25rem' }}>{cert.title}</h3>
                  <p style={{ color: 'var(--accent)', fontSize: '0.85rem', marginBottom: '0.25rem' }}>{cert.issuer}</p>
                  <p style={{ color: 'var(--text-subtle)', fontSize: '0.8rem', marginBottom: '0.5rem' }}>{new Date(cert.date).toLocaleDateString('en-US', { year: 'numeric', month: 'short' })}</p>
                  {cert.credential_url && <a href={cert.credential_url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.8rem', color: 'var(--accent)' }}>Verify <ExternalLink size={12} /></a>}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
